// extracted by mini-css-extract-plugin
export default {"loginForm":"LoginForm_loginForm__NH8NP"};